import _slicedToArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useCallback, useState, useEffect } from 'react';

var isControlledMode = function isControlledMode(value) {
  return value !== undefined;
};

var isLabelPositionInside = function isLabelPositionInside(_ref) {
  var value = _ref.value,
      placeholder = _ref.placeholder,
      disableLabelEffect = _ref.disableLabelEffect,
      isFocused = _ref.isFocused,
      isEmptyUncontrolled = _ref.isEmptyUncontrolled;

  if (placeholder || isFocused || disableLabelEffect) {
    return false;
  }

  if (isControlledMode(value)) {
    return !value;
  }

  return isEmptyUncontrolled;
};

export var useEvents = function useEvents(_ref2) {
  var value = _ref2.value,
      defaultValue = _ref2.defaultValue,
      placeholder = _ref2.placeholder,
      disableLabelEffect = _ref2.disableLabelEffect,
      onFocus = _ref2.onFocus,
      onBlur = _ref2.onBlur,
      onMouseOver = _ref2.onMouseOver,
      onMouseOut = _ref2.onMouseOut,
      readOnly = _ref2.readOnly,
      onChange = _ref2.onChange;

  var _useState = useState(!defaultValue),
      _useState2 = _slicedToArray(_useState, 2),
      isEmptyUncontrolled = _useState2[0],
      setEmptyUncontrolled = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isFocused = _useState4[0],
      setFocused = _useState4[1];

  var _useState5 = useState(isLabelPositionInside({
    value: value,
    defaultValue: defaultValue,
    placeholder: placeholder,
    disableLabelEffect: disableLabelEffect,
    isFocused: isFocused,
    isEmptyUncontrolled: isEmptyUncontrolled
  })),
      _useState6 = _slicedToArray(_useState5, 2),
      isLabelInside = _useState6[0],
      setLabelInside = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isMouseInside = _useState8[0],
      setMouseInside = _useState8[1];

  useEffect(function () {
    setLabelInside(isLabelPositionInside({
      value: value,
      defaultValue: defaultValue,
      isFocused: isFocused,
      placeholder: placeholder,
      disableLabelEffect: disableLabelEffect,
      isEmptyUncontrolled: isEmptyUncontrolled
    }));
  }, [value, defaultValue, isFocused, placeholder, disableLabelEffect, isEmptyUncontrolled, readOnly]);
  var onInputChange = useCallback(function (event) {
    if (onChange) {
      onChange(event);
    }

    if (event.isPropagationStopped()) {
      return;
    }

    if (!isControlledMode(value)) {
      setEmptyUncontrolled(!event.target.value.length);
    }
  }, [onChange, value]);
  var onInputFocus = useCallback(function (event) {
    setFocused(true);

    if (onFocus) {
      onFocus(event);
    }
  }, [isLabelInside, setLabelInside, onFocus, readOnly]);
  var onInputBlur = useCallback(function (event) {
    setFocused(false);

    if (onBlur) {
      onBlur(event);
    }
  }, [isLabelInside, placeholder, setFocused, setLabelInside, onBlur]);
  var onInputMouseOver = useCallback(function (event) {
    setMouseInside(true);

    if (onMouseOver) {
      onMouseOver(event);
    }
  }, []);
  var onInputMouseOut = useCallback(function (event) {
    setMouseInside(false);

    if (onMouseOut) {
      onMouseOut(event);
    }
  }, []);
  return {
    isMouseInside: isMouseInside,
    isLabelInside: isLabelInside,
    isFocused: isFocused,
    onInputMouseOver: onInputMouseOver,
    onInputMouseOut: onInputMouseOut,
    onInputFocus: onInputFocus,
    onInputBlur: onInputBlur,
    onInputChange: onInputChange
  };
};